import React from 'react';
import "../Figure.css"


function Figure27() {
  return (
    <div>
        <table class="equal-width-table">
          <thead>
            <tr>
              <th> Blanks (no Zn added)</th>
              <th>Zn concentration</th>
            </tr>
          </thead>
          <tbody>
          <tr>
              <th>  Water </th>
              <td> 0.21 mg/L </td>
            </tr> 
            <tr>
              <th>  EC20 </th>
              <td> 0.29 mg/L </td>
            </tr> 
            <tr>
              <th>  SpaC </th>
              <td> 0.26 mg/L </td>
            </tr>          
          </tbody>
        </table>
    </div>
  );
}

export default Figure27;